import { useRef } from 'react'

export function WhatIsWellnessLoopSection() {
  const ref = useRef(null)

  return (
    <section className="bg-cream-50">
      <div className="mx-auto flex max-w-5xl flex-col items-center gap-6 px-6 py-12 md:flex-row md:items-center md:gap-12 lg:py-16">
        <p className="text-center text-xl leading-snug text-gray-800 sm:text-2xl md:w-2/5 md:shrink-0 md:text-left lg:text-3xl">
          Wellness isn&apos;t a one-time event.{' '}
          <span className="font-semibold text-primary-700">It&apos;s a continous process..</span>
        </p>

        <div
          ref={ref}
          className="relative w-full md:w-3/5"
        >
          <img
            src="/Actual Loop.svg"
            alt=""
            aria-hidden="true"
            className="h-auto w-full"
          />
        </div>
      </div>
    </section>
  )
}
